/**
 * Runtime base-URL derivation — port of v1's web/dashboard/src/lib/runtime-base-urls.ts.
 *
 * One bundle serves every brand variant. Hostname → API/widget base mapping:
 *   app.aloragiving.com         → api.aloragiving.com  / widget.aloragiving.com
 *   app.v2.aloragiving.com      → api.aloragiving.com  / widget.aloragiving.com   (v2 staging)
 *   my.mohseen.app              → api.mohseen.app      / widget.mohseen.app
 *   app.v2.mohseen.app          → api.mohseen.app      / widget.mohseen.app       (v2 staging)
 *   app.alorachurch.com         → api.alorachurch.com  / widget.alorachurch.com
 *   app.v2.alorachurch.com      → api.alorachurch.com  / widget.alorachurch.com   (v2 staging)
 *   localhost                   → /api proxy via Vite (see vite.config.ts)
 *
 * Canonical per `forge_runtime_base_urls_canonical.md` memory. Hand-rolling
 * hostname derivation elsewhere is a smell — route through this module.
 */

export type Brand = "aloragiving" | "mohseen" | "alorachurch" | "unknown";

const ROOT_DOMAINS: Record<Brand, string> = {
  aloragiving: "aloragiving.com",
  mohseen: "mohseen.app",
  alorachurch: "alorachurch.com",
  unknown: "",
};

export function detectBrand(hostname: string = window.location.hostname): Brand {
  if (hostname.endsWith("mohseen.app")) return "mohseen";
  if (hostname.endsWith("alorachurch.com")) return "alorachurch";
  if (hostname.endsWith("aloragiving.com")) return "aloragiving";
  return "unknown";
}

export function deriveApiBase(hostname: string = window.location.hostname): string {
  if (hostname === "localhost" || hostname === "127.0.0.1") return "/api/v1";
  const brand = detectBrand(hostname);
  if (brand === "unknown") return "/api/v1";
  const root = ROOT_DOMAINS[brand];
  return `https://api.${root}/api/v1`;
}

export function deriveWidgetBase(hostname: string = window.location.hostname): string {
  if (hostname === "localhost" || hostname === "127.0.0.1") return "http://localhost:3001";
  const brand = detectBrand(hostname);
  if (brand === "unknown") return "";
  const root = ROOT_DOMAINS[brand];
  return `https://widget.${root}`;
}

/** True when the current hostname is one of the v2 staging hostnames. */
export function isV2StagingHost(hostname: string = window.location.hostname): boolean {
  return /^app\.v2\./.test(hostname);
}
